import { SimpleGrid, createStyles, rem, Skeleton, Flex, Group } from "@mantine/core"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  grid: {
    gap: `${rem(64)} ${rem(32)}`,

    [theme.fn.smallerThan("md")]: {
      gap: `${rem(48)} ${rem(24)}`,
    },

    [theme.fn.smallerThan("xs")]: {
      gap: `${rem(64)} ${rem(32)}`,
    },
  },
}))

// ----------------------------------------------------------------------

export function InstructorListSkeleton(): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <SimpleGrid
      cols={3}
      breakpoints={[
        { maxWidth: "md", cols: 2 },
        { maxWidth: "xs", cols: 1 },
      ]}
      className={classes.grid}
    >
      {new Array(6).fill(null).map((_, index) => (
        <Flex key={index} direction="column" align="center">
          <Skeleton height={435} width="100%" radius="xl"/>
          <Skeleton height={18} mt="xl" width="70%"/>
          <Skeleton height={14} mt="md" width="50%"/>
          <Group mt="md" position="center" spacing="md">
            {new Array(Math.floor(Math.random() * (3 - 1) + 1)).fill(null).map((__, key) => (
              <Skeleton key={`social_${key}`} height={36} circle mb="xl"/>
            ))}
          </Group>
        </Flex>
      ))}
    </SimpleGrid>
  )
}
